<template>
  <div>
    <!-- scrollToTop start here -->
    <a
      href="#"
      class="scrollToTop"
      style="bottom: -30%; opacity: 0; transition: all 0.5s ease 0s;"
      ><i class="mdi mdi-arrow-up-bold"></i><span class="pluse_1"></span
      ><span class="pluse_2"></span
    ></a>
    <!-- scrollToTop ending here -->
  </div>
</template>

<script>
export default {
  name: "ScrollToTop",
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
